import type { Section } from "@/components/ui";

/**
 * The sections of the console that have several pages, each written ONCE: its name (the eyebrow of
 * its pages) and its tabs. The sidebar lands on the first tab, so a page added here appears in the
 * tabs of every page of the section and nowhere else needs to hear about it.
 *
 * A section's editors and detail pages carry no tabs: they say where they came from with a back
 * link, and the sidebar keeps the section lit.
 */
export const CATALOG: Section = {
  label: "Catalog",
  tabs: [
    { to: "/catalog/gateways", label: "Gateway types" },
    { to: "/catalog/components", label: "Components" },
  ],
};

export const MESSAGING: Section = {
  label: "Messaging",
  tabs: [
    { to: "/messaging/emails", label: "Emails" },
    { to: "/messaging/templates", label: "Templates" },
    { to: "/messaging/campaigns", label: "Campaigns" },
  ],
};

export const FACTORY: Section = {
  label: "Factory",
  tabs: [
    { to: "/factory/runners", label: "Runners" },
    { to: "/factory/credentials", label: "Credentials" },
  ],
};
